
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuCafeHarajukuGyoretsuCafeImage } from "@src/constants/images";
import { meta as micasadecoPageMeta } from "./micasadeco.mdx";
import { meta as initialPageMeta } from "./initial.mdx";
import { meta as chavatyPageMeta } from "./chavaty.mdx";
export const meta = {
  path: "/media/harajuku/cafe",
  title: "【行列情報あり！】原宿で行列のできる人気カフェ４選",
  description: "原宿で行列のできる人気のカフェを４選に厳選してご紹介します。ランチやカフェ激戦区という原宿の中でも、土日を中心に連日行列ができているお店の詳細、人気のメニュー、行列情報の３点に絞ってご紹介します。原宿で人気のカフェに足を運んでみたい時には、ぜひこちらの記事をチェックしてみてください。",
  topImg: harajukuCafeHarajukuGyoretsuCafeImage,
  author: murakamiMasanori,
  tags: ["カフェ", "行列店", "人気店", "おしゃれな内装", "人気店", "まとめ記事", "食べログ高評価", "行列情報"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿で行列のできる人気のカフェを４選に厳選してご紹介します。`}</p>
    <p>{`ランチやカフェ激戦区という原宿の中でも、土日を中心に連日行列ができているお店の詳細、人気のメニュー、行列情報の３点に絞ってご紹介します。`}</p>
    <p>{`北海道発祥の「シメパフェ」の人気店、紅茶を専門にした人気カフェ、2020 年にリニューアルしたてのパンケーキカフェの人気カフェ、朝から行列ができる原宿エリア 1 番のカフェなど、それぞれお店の特徴が詰まっています。原宿で人気のカフェに足を運んでみたい時には、ぜひこちらの記事をチェックしてみてください。`}</p>
    <h2>{`INITIAL`}</h2>
    <InstaImage postId="B0hgREdAxlR" mdxType="InstaImage" />
    <p>{`北海道発祥のお店で、2019 年 5 月 1 日にオープンしたばかりのパフェの専門店で、カフェとしても利用ができます。
飲み会の後にシメとしてパフェを食べる文化が北海道では定番となり、その人気店が東京に上陸しました。`}</p>
    <h3>{`苺のパフェ`}</h3>
    <InstaImage postId="Bxd1PSfA3QW" mdxType="InstaImage" />
    <p>{`INITIAL のシメパフェの中で、最も人気な看板メニューがこちらの苺のパフェ。美しさとボリュームの両方を兼ね備えたパフェで、カフェの雰囲気も楽しみながら堪能していただければと思います。`}</p>
    <h3>{`行列情報`}</h3>
    <p>{`原宿のカフェの中でも、INITIAL は指折りの行列のできるお店になります。平日のカフェタイムは行列になることは少ないですが、休日は大行列ができていることが多いです。特に、12~16 時頃の間は、長い時で 1 時間以上待たないといけないこともあるため、早めの時間帯でカフェタイムを過ごすことをオススメします。`}</p>
    <LinkWithThumbnail meta={initialPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brqcafi23akg00ce85dg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`CHAVATY`}</h2>
    <InstaImage postId="B-TwBNZlte4" mdxType="InstaImage" />
    <InstaImage postId="B9WlrPmgH75" mdxType="InstaImage" />
    <p>{`紅茶専門店のカフェとして 2018 年 7 月にオープンし、原宿と表参道の間に位置するお店です。茶葉をベースとした紅茶やスイーツを取り揃えており、インスタ映えするスイーツや紅茶が話題となって、連日行列を作る人気のカフェ。`}</p>
    <h3>{`紅茶とスコーンのセット`}</h3>
    <p>{`紅茶とスコーンのセットは、３種類の紅茶から好きなティー１つ選ぶことができ、チャバティー自家製のスコーンが２個食べられるお得なセットになっています！`}</p>
    <p>{`塩ホイップクリームやハニーナッツがスコーンのセットにはついているので、紅茶と一緒にいろんな味が楽しめるのも魅力的なポイントですよね。`}</p>
    <h3>{`行列情報`}</h3>
    <p>{`カフェタイムの時間帯の 13 時〜16 時は行列ができることが多く、長い時では 1 時間程度待ち時間があることも。行列の時には、レーンのようなものに並ばないといけないので、暑い日や寒い日は待つことがかなり大変になります。行列になりやすい時間帯を避けて、カフェの時間を楽しんでいただければと思います。`}</p>
    <LinkWithThumbnail meta={chavatyPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="bree01a23akg00eoptj0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`ミカサデコ&カフェ`}</h2>
    <InstaImage postId="B-ZnzvKHE90" mdxType="InstaImage" />
    <p>{`キャットストリートから裏原方面へ進んでいくと、青い外観をしたお店が 2 ミカサデコ&カフェです。
2020 年 3 月に神宮前に移転したばかりなので、店内は清潔感があり、スタイリッシュ。`}</p>
    <p>{`「大人が楽しめるカフェ」をコンセプトにしており、雰囲気が抜群なのはもちろんのこと、スイーツからランチメニューまで豊富なラインナップで注文できるのが魅力。`}</p>
    <h3>{`ふわふわリコッタチーズパンケーキ`}</h3>
    <InstaImage postId="B4txPmqg4E3" mdxType="InstaImage" />
    <p>{`ミカサデコカフェ(MICASADECO&CAFE)の 1 番人気のメニューになります。
注文を受けてから出てくるまで 30 分かかるのですが、一枚一枚丁寧に焼き上げるパンケーキは、驚くほどふわふわで、`}<strong parentName="p">{`踊るパンケーキ`}</strong>{`と言われています。`}</p>
    <p>{`コーヒーや紅茶と一緒に甘いパンケーキを食べる至福のカフェタイムを過ごしてみてください！`}</p>
    <h3>{`行列情報`}</h3>
    <p>{`カフェタイムの時間帯の 14 時〜16 時の時間帯は最も行列ができやすく、1 時間待ちになる可能性もあります。人気のパンケーキが注文を受けてから 30 分ほどかかり、席数が多くないのでカフェの時間帯には行列ができやすくなってしまうそう。平日だと行列ができることは少ないですが、休日にお越しの際には時間の工夫などが必要です。`}</p>
    <LinkWithThumbnail meta={micasadecoPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="breespi23akg00eoptr0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`パンとエスプレッソと`}</h2>
    <InstaImage postId="B9I0YuFlg7U" mdxType="InstaImage" />
    <p>{`原宿と表参道の中間に位置するお店で、4 年連続食べログの百名店に選出、食べログの評価は 3.8 を超える人気店。
焼き立てのパンを求めて、朝の時間帯から行列ができていることも多いそうで、ランチやカフェタイムとしても利用ができます。`}</p>
    <p>{`広々としたテラス席も完備しているので、天気の良い日にはテラス席でカフェタイムができるのも特徴。`}</p>
    <h3>{`カフェメニュー`}</h3>
    <InstaImage postId="CBo4ewglpm5" mdxType="InstaImage" />
    <InstaImage postId="B_WaTdfFjP5" mdxType="InstaImage" />
    <p>{`パニーニやキッシュをはじめとして、普段なら食べる機会が少ないパンのメニューだけでなく、
エスプレッソコーヒーやカフェラテ、紅茶など、パンに合うメニューが豊富に取り揃えられております。`}</p>
    <p>{`また、カップや持ち帰り用の袋などに、お店のロゴが使われており、
お店のグッズも写真を UP したくなるようなデザインに仕上がっているのも人気の秘密です。`}</p>
    <h3>{`行列情報`}</h3>
    <p>{`パン屋さんということもあって、昼のカフェタイムの時間帯は土日の時間帯でも比較的空いていることが多いです。
朝の時間帯の方が行列ができることが多いので、土日でなるべく並ばずにカフェタイムを過ごしたい方にはオススメなお店となっております。`}</p>
    <ShopInfoBox shopId="brisonq23akg00cd2nfg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿で行列のできる人気のカフェをご紹介してきましたが、いかがでしたでしょうか。
それぞれのお店に人気店ならではの特徴があり、行列ができているのだと思います。
期になるお店を見つけたら、ぜひ足を運んで素敵なカフェタイムをお過ごしください。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;